import { render, staticRenderFns } from "./newprofile.vue?vue&type=template&id=5a7828e0&scoped=true"
import script from "./newprofile.vue?vue&type=script&lang=js"
export * from "./newprofile.vue?vue&type=script&lang=js"
import style0 from "./newprofile.vue?vue&type=style&index=0&id=5a7828e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7828e0",
  null
  
)

export default component.exports